var render, staticRenderFns
import script from "./detailTable.vue?vue&type=script&lang=js"
export * from "./detailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0727b64e')) {
      api.createRecord('0727b64e', component.options)
    } else {
      api.reload('0727b64e', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_without_business_license/form/detailTable.vue"
export default component.exports